import { WithdrawMyAccountResponse, SupportedCurrencies } from 'vopay';
import { useState } from 'react';
import { api } from '@/services/api.config';

export type WithdrawMyAccount = {
  Token: string;
  Currency: SupportedCurrencies;
  ClientAccountID?: string;
  Amount: number;
  ClientReferenceNumber?: string;
  Notes?: string;
  ParentTransactionID?: string;
};

export default function useWithdrawMyAccount() {
  const [fetching, setFetching] = useState(false);

  async function withdrawMyAccount(params: WithdrawMyAccount): Promise<WithdrawMyAccountResponse> {
    try {
      setFetching(true);
      const res = await api.postWithdrawMyAccount({
        Amount: params.Amount || 0,
        Currency: params.Currency,
        ClientReferenceNumber: params.ClientReferenceNumber,
        Notes: params.Notes,
        ClientAccountID: params.ClientAccountID,
        ParentTransactionID: params.ParentTransactionID,
      });

      if (!res.Success) throw new Error(res.ErrorMessage);

      return res;
    } catch (error) {
      console.error(error);
      throw error;
    } finally {
      setFetching(false);
    }
  }

  return { fetching, withdrawMyAccount };
}
